module.exports = __webpack_public_path__ + "img/protester7.eb1041b1.jpg";